module.exports = __webpack_public_path__ + "static/media/pic9.e1e53623.jpg";